import { render } from "./material-list.vue?vue&type=template&id=50c60b03&scoped=true"
import script from "./material-list.vue?vue&type=script&lang=js"
export * from "./material-list.vue?vue&type=script&lang=js"

import "./material-list.vue?vue&type=style&index=0&id=50c60b03&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c60b03"]])

export default __exports__